import { useEffect, useState, useRef, useCallback } from 'react';

export const useResponsive = () => {
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const resizeTimeout = useRef(null);

    const getBrowserWidth = () => {
        if (typeof window === 'undefined') return 1024; // fallback
        try {
            return window.top.innerWidth;
        } catch {
            try {
                return window.parent.innerWidth;
            } catch {
                return window.innerWidth;
            }
        }
    };

    const updateScreenSize = useCallback(() => {
        const width = getBrowserWidth();
        setIsSmallScreen(width < 550);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            if (resizeTimeout.current) {
                clearTimeout(resizeTimeout.current);
            }
            resizeTimeout.current = setTimeout(() => {
                updateScreenSize();
                resizeTimeout.current = null;
            }, 150);
        };

        updateScreenSize();
        window.addEventListener('resize', handleResize, { passive: true });

        return () => {
            if (resizeTimeout.current) {
                clearTimeout(resizeTimeout.current);
                resizeTimeout.current = null;
            }
            window.removeEventListener('resize', handleResize);
        };
    }, [updateScreenSize]);

    return isSmallScreen;
};
